const comments = [
  {
    author: '吃瓜不嫌事大',
    avatar: 'R',
    time: '2小时前',
    content: '终于有人整理了！之前一直零零散散看这些八卦，51黑料吃瓜网一次性全汇总太方便了，收藏了收藏了。这个黑料吃瓜最新地址必须安利给身边的吃瓜群友们。',
    likes: '128',
  },
  {
    author: '八卦探测器',
    avatar: '八',
    time: '5小时前',
    content: '作为资深吃瓜群众，我表示这个网站真的太懂我们了。更新速度快得离谱，早上刚发生的爆料下午就上了51吃瓜官网全网最新首页，比微博热搜还快。51黑料入口真的稳。',
    likes: '96',
  },
  {
    author: '娱乐圈课代表',
    avatar: '课',
    time: '8小时前',
    content: '页面设计也很舒服，分类清晰，找自己想吃的瓜很方便。特别是热度榜单那个板块，吃瓜网站首页直接看排行榜，不用自己一个个搜，懒人福音啊。51吃瓜网站入口已设为浏览器首页！',
    likes: '73',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            网友热评
          </h2>
          <p className="mt-2 text-sm text-foreground-500">吃瓜群众的真实声音</p>
        </div>
        <div className="space-y-4">
          {comments.map((comment, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5"
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-sm font-semibold text-accent-600">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                      {comment.author}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
                  <div className="mt-2 flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-heart-line"></i>
                      {comment.likes}
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}